import emailInput from './email/email';
import emailLogin from './email/login';
import emailReg from './email/reg';
import emailAct from './email/act';
export default {
  name: 'emailwrap',
  props: {
    wayType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      regType: 'input',
      email: '',
      token: ''
    };
  },
  components: {
    'email-input': emailInput,
    'email-reg': emailReg,
    'email-act': emailAct,
    'email-login': emailLogin
  },
  methods: {
    successHandle: function successHandle(data) {
      this.$emit('success', data);
    },
    showForgetHandle: function showForgetHandle(type, name) {
      this.$emit('showForget', type, name);
    },
    inputEmailHandle: function inputEmailHandle(type, name, token) {
      this.regType = type;
      this.email = name;
      this.token = token;
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};